<div class="page-shell">
  <mat-toolbar class="header">
    <span>{{ "menu.signatures.predefined" | translate }}</span>
    <div *ngIf="canEdit" class="actions">
      <button
        mat-stroked-button
        type="button"
        (click)="toggleReordering()"
        [disabled]="isSendingRequest || initialLoading"
      >
        <span *ngIf="!isReordering">{{ "predefined.reorder" | translate }}</span>
        <span *ngIf="isReordering">{{ "predefined.saveReorder" | translate }}</span>
      </button>
      <a
        mat-raised-button
        color="primary"
        *ngIf="!isReordering"
        [routerLink]="['new']"
        [class.disabled]="initialLoading"
      >
        {{ "predefined.new" | translate }}
      </a>
    </div>
  </mat-toolbar>

  <div class="content-wrapper">
    <div
      class="empty-state"
      *ngIf="!initialLoading && signatures?.length === 0"
    >
      <mat-icon class="empty-state__icon">library_books</mat-icon>
      <p>{{ "predefined.empty" | translate }}</p>
    </div>

    <ul
      class="signature-list"
      *ngIf="signatures?.length"
      [dragula]="isReordering ? 'predefined' : undefined"
      [(dragulaModel)]="signatures"
    >
      <li
        *ngFor="let signature of signatures"
        class="signature-list-item"
        [class.reordering]="isReordering"
        [appTableRowLink]="predefinedDetailLink(signature)"
        [appTableRowLinkRelativeTo]="route"
        [appTableRowLinkDisabled]="!canEdit || isReordering"
      >
        <app-signature-predefined-item
          [signature]="signature"
          [canReorder]="isReordering"
        >
          <div class="table-actions" (click)="$event.stopPropagation()">
            <a
              *ngIf="canEdit"
              class="action-btn"
              [routerLink]="[signature.templatePredefinedId]"
            >
              <mat-icon>edit</mat-icon>
              {{ "edit" | translate }}
            </a>
            <button
              type="button"
              class="action-btn"
              (click)="copyPredefinedToClient(signature.templatePredefinedId)"
            >
              <mat-icon>download</mat-icon>
              {{ "predefined.save" | translate }}
            </button>
            <button
              type="button"
              class="action-btn action-btn--danger"
              *ngIf="canEdit"
              (click)="deletePredefined(signature.templatePredefinedId)"
            >
              <mat-icon>delete_outline</mat-icon>
              {{ "delete" | translate }}
            </button>
          </div>
        </app-signature-predefined-item>
      </li>
    </ul>

    <div class="dbc1-loading dbc1-loading--overlay" *ngIf="initialLoading">
      <app-loading></app-loading>
    </div>
  </div>
</div>
